/*
 * @Author: pingping.mao
 * @Date: 2022-12-30 14:45:43
 * @LastEditTime: 2023-01-04 14:26:50
 * @LastEditors: pingping.mao
 * @Description:
 * @FilePath: \common-web\src\api\parameter-template\index.js
 */
import request from '@/utils/request';
const systemUrl = window.env.scimSystem;
const api = {
  getParamsTemplate: params => request({
    url: `${systemUrl}/api/v1/parameter-config-template/list`,
    method: 'get',
    params
  }),
  getModuleParamsById: params => request({
    url: `${systemUrl}/api/v1/parameter-config-template/id`,
    method: 'get',
    params
  }),
  getParamsValueByIdAndOrgId: ({ templateId, useOrgId, ...args }) => request({
    url: `${systemUrl}/api/v1/parameter-config/templateId/${templateId}/useOrgId/${useOrgId}`,
    method: 'get',
    params: args
  }),
  batchAddOrUpdate(data) {
    return request({
      url: `${systemUrl}/api/v1/parameter-config/batch/save-or-update`,
      method: 'post',
      data: {
        keys: data
      }
    });
  },
  addModule(data) {
    return request({
      url: `${systemUrl}/api/v1/parameter-config-template`,
      method: 'post',
      data
    });
  },
  editModule(data) {
    return request({
      url: `${systemUrl}/api/v1/parameter-config-template`,
      method: 'put',
      data
    });
  },
  deleteModule(params) {
    return request({
      url: `${systemUrl}/api/v1/parameter-config-template`,
      method: 'delete',
      params
    });
  },
  syncSingle(params) {
    return request({
      url: `${systemUrl}/api/v1/parameter-config-template/sync-single`,
      method: 'get',
      params
    });
  },
  batchSyncTemplate(data) {
    return request({
      url: `${systemUrl}/api/v1/parameter-config-template/sync/batch`,
      method: 'post',
      data
    });
  }
};
export default api;
